<template>
  <div
    class="button-add-to-cart"
    data-qa-id="button-add-to-cart"
  >
    <fn-tooltip
      :open="tooltipOpen"
      full-width
    >
      <template #default>
        <fn-button
          id="addToCart"
          class="batc-button"
          icon="add-to-cart-new-bold"
          icon-size="s"
          icon-position="center"
          :aria-label="$t('cart.buttons.addToCart')"
          :disabled="disabled"
          :status="buttonStatus"
          :secondary="secondary"
          :quinary-alt="quinaryAlt"
          :data-name="dataName || undefined"
          :data-audience="dataAudience"
          @click="$emit('addToCart')"
        >
          <template v-if="buttonStatus === 'success'">
            {{ $t('cart.buttons.addedToCart') }}
          </template>
          <template v-else-if="buttonStatus === 'error'">
            {{ $t('cart.buttons.errorAddingToCart') }}
          </template>
          <template v-else-if="buttonStatus === 'loading'">
            {{ $t('cart.buttons.addingToCart') }}
          </template>
          <template v-else>
            {{ text || $t('cart.buttons.addToCart') }}
          </template>
        </fn-button>
      </template>
      <template #popover>
        <div
          v-if="!hideTooltip"
          class="add-to-cart-tooltip"
        >
          <template v-if="status === 'lowStock'">
            {{ $t('cart.errors.lowStock') }}
          </template>
          <template v-else-if="status === 'maxOrderQuantityExceeded'">
            {{ $t('cart.errors.maxOrderQuantityExceeded') }}
          </template>
          <template v-else-if="status === 'itemLimitExceeded'">
            {{ $t('cart.errors.itemLimitExceeded') }}
          </template>
        </div>
      </template>
    </fn-tooltip>
  </div>
</template>

<script>
export default defineComponent({
  props: {
    status: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
    },
    secondary: {
      type: Boolean,
    },
    quinaryAlt: {
      type: Boolean,
    },
    text: {
      type: String,
      default: '',
    },
    hideTooltip: {
      type: Boolean,
    },
    dataName: {
      type: String,
      default: '',
    },
    dataAudience: {
      type: String,
      default: '',
    },
  },
  emits: ['addToCart'],
  computed: {
    buttonStatus() {
      if (this.status === 'error') {
        return 'error';
      }

      if (this.status === 'loading') {
        return 'loading';
      }

      if (!this.status) {
        return null;
      }

      return 'success';
    },

    tooltipOpen() {
      return (
        this.status === 'lowStock' || this.status === 'maxOrderQuantityExceeded' || this.status === 'itemLimitExceeded'
      );
    },
  },
});
</script>

<style lang="scss" scoped>
.button-add-to-cart {
  .batc-button {
    padding: math.div($pad, 2);
    height: $ui-height;
    max-height: $ui-height;
    line-height: inherit;

    &:focus-visible {
      @include focus-outline-default;
      background-color: $color-action-background-primary-default-hover;
    }
  }
}

.add-to-cart-tooltip {
  padding: $pad;
  max-width: 320px;
}
</style>
